<template>
  <div>
    <p v-html="credits" class="credits"/>
  </div>
</template>

<script>
export default {
  name: 'Credits',
  data: function () {
    return {
      credits: "Artwork: <a href='http://www.lieuwkje.nl'>Lieuwkje</a> &nbsp;&nbsp;&nbsp; | &nbsp;&nbsp;&nbsp; Production: <a href='http://www.yodo.nl'>Yodo</a>"
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .credits {
   animation: credits-wiggle 6s infinite ease-in-out;
   padding-top: 60px;
   padding-bottom: 60px;
 }
 @keyframes credits-wiggle {
   33% {
     transform: rotate(5deg);
   }
   66% {
     transform: rotate(-5deg);
   }
   98%{
     transform: rotate(0deg);
   }
   99%{
     transform: rotate(180deg);
   }
   100%{
     transform: rotate(0deg);
   }
 }
</style>
